"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.323 6.5H19.5a1 1 0 0 1 1 1V9a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V7.5a1 1 0 0 1 1-1H9a2.5 2.5 0 1 1 3.76-3.07 2 2 0 0 1 2.562 3.07M9 4.5A1.5 1.5 0 0 0 10.5 6H12V4.5a1.5 1.5 0 0 0-3 0M14 6a1 1 0 1 0-1-1v1zM4.5 17v-6H10v8H6.5a2 2 0 0 1-2-2m6.5-6v8h2v-8zm8.5 6v-6H14v8h3.5a2 2 0 0 0 2-2"
}), 'GiftFilled');
//# sourceMappingURL=index.js.map